import { all, takeLatest, call, put } from 'redux-saga/effects';
import Axios, { AxiosResponse } from 'axios';
import {
  getAnonymousEnquirySuccess,
  getAnonymousEnquiryFailure,
  getAnonymousEnquiryAutoRenewPropertiesSuccess,
  getAnonymousEnquiryAutoRenewPropertiesFailure,
  getAnonymousCredentialSuccess,
  getAnonymousCredentialFailure
} from './actions';
import { AnonymousViewActionTypes } from './types';
import {
  getAnonymousEnquiry,
  getAnonymousEnquiryAutoRenewProperties
} from 'services/enquiry.service';
import { getAnonymousCredential } from 'services/user.service';

function* handleGetAnonymousEnquiry(request: any) {
  try {
    const response: AxiosResponse = yield getAnonymousEnquiry(request.payload);
    if (response) {
      yield put(getAnonymousEnquirySuccess(response.data));
    } else {
      yield put(getAnonymousEnquiryFailure('Unable to get anonymous enquiry'));
    }
  } catch (err) {
    const errMsg = Axios.isAxiosError(err)
      ? err.response?.data?.msg
      : undefined;
    yield put(
      getAnonymousEnquiryFailure(errMsg || 'Unable to get anonymous enquiry')
    );
  }
}

function* handleGetAnonymousEnquiryAutoRenewProperties(request: any) {
  try {
    const response: AxiosResponse =
      yield getAnonymousEnquiryAutoRenewProperties(request.payload);
    if (response) {
      yield put(getAnonymousEnquiryAutoRenewPropertiesSuccess(response.data));
    } else {
      yield put(
        getAnonymousEnquiryAutoRenewPropertiesFailure(
          'Unable to get anonymous enquiry auto renew properties'
        )
      );
    }
  } catch (err) {
    const errMsg = Axios.isAxiosError(err)
      ? err.response?.data?.msg
      : undefined;
    yield put(
      getAnonymousEnquiryAutoRenewPropertiesFailure(
        errMsg || 'Unable to get anonymous enquiry auto renew properties'
      )
    );
  }
}

function* handleGetAnonymousCredential(request: any) {
  try {
    const response: AxiosResponse = yield getAnonymousCredential(
      request.payload
    );
    if (response?.data) {
      yield put(getAnonymousCredentialSuccess(response.data));
    } else {
      put(getAnonymousCredentialFailure('Unable get anonymous crendetials'));
    }
  } catch (err) {
    const msg = Axios.isAxiosError(err) ? err.response?.data?.msg : undefined;
    yield put(
      getAnonymousCredentialFailure(msg || 'Unable get anonymous crendetials')
    );
  }
}

function* watchGetAnonymousEnquiry() {
  yield takeLatest(
    AnonymousViewActionTypes.GET_ANONYMOUS_ENQUIRY_START,
    handleGetAnonymousEnquiry
  );
}

function* watchGetAnonymousEnquiryAutoRenewProperties() {
  yield takeLatest(
    AnonymousViewActionTypes.GET_ANONYMOUS_ENQUIRY_AUTO_RENEW_PROPERTIES_START,
    handleGetAnonymousEnquiryAutoRenewProperties
  );
}

function* watchGetAnonymousCredential() {
  yield takeLatest(
    AnonymousViewActionTypes.GET_ANONYMOUS_CREDENTIAL_START,
    handleGetAnonymousCredential
  );
}

function* sagas() {
  yield all([
    call(watchGetAnonymousEnquiry),
    call(watchGetAnonymousEnquiryAutoRenewProperties),
    call(watchGetAnonymousCredential)
  ]);
}

export default sagas;
